import { useEffect, useMemo } from 'react';
import { fCurrency } from '../../utils/formatNumber';
import { useRadioGroup } from '../../hooks/useRadioGroup';
import { Payment as PaymentUtil } from '../../utils/payment';
import type { TestProps } from '../../models';

interface PaymentOptionSelectorProps {
	tests: TestProps[];
	onChange: (amount: number, type: 'full' | 'split') => void;
}

export const PaymentOptionSelector = ({ tests, onChange }: PaymentOptionSelectorProps) => {
	const payment = useMemo(() => new PaymentUtil(tests), [tests]);
	const total = useMemo(() => payment.total(), [payment]);
	const deposit = useMemo(() => payment.deposit(), [payment]);
	const balance = useMemo(() => payment.balance(), [payment]);
	const depositWithoutGST = useMemo(() => payment.depositWithoutGST(), [payment]);
	const totalWithoutGST = useMemo(() => payment.totalWithoutGST(), [payment]);

	const { RadioGroup: PaymentOptions, value } = useRadioGroup({
		options: [
			{
				label: `Pay ${fCurrency(Number(total))} now`,
				value: 'full',
			},
			{
				label: 'Pay 30% now, 70% later',
				subtitle: `Pay ${fCurrency(Number(deposit))} now, ${fCurrency(Number(balance))} after test completion.`,
				value: 'split',
			},
		],
	});

	useEffect(() => {
		const amount = value === 'full' ? totalWithoutGST : depositWithoutGST;
		onChange(amount, value as 'full' | 'split');
	}, [value, depositWithoutGST, totalWithoutGST, onChange]);

	return <PaymentOptions />;
};
